




































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { QueryManipulator } from '@/router'
import OsdEditor from '@/components/dialogs/OsdEditor.vue'
import RadioIcon from '@/components/RadioIcon.vue'
import { OsdConfig } from '@/types/api'
import { reqMan } from '@/singleton'

export default mixins(generalDialogMixin).extend({
  components: {
    OsdEditor,
    RadioIcon,
  },
  data (): {
    chosenOsdId: number
  } {
    return {
      chosenOsdId: 0
    }
  },
  computed: {
    osdList (): OsdConfig[] { return this.$state.device.osd.list }
  },
  methods: {
    create () {
      this.$router.push({ name: `${this.$route.name}_create` })
    },
    edit (osdId: number) { this.$router.push({ name: `${this.$route.name}_edit`, params: {osdid: osdId + ''} }) },
    deleteOsd (osdId: number) { this.$router.push({ name: `${this.$route.name}_delete`, params: {osdid: osdId + ''} }) },
    apply () {
      this.$emit('osdSelect', this.chosenOsdId)
      this.closeThisDialog()
    }
  },
  watch: {
  },
  mounted () {
    console.log('OsdSelector MOUNTED')
    this.chosenOsdId = ~~this.$route.query['selected_osd_id']
    reqMan.ensureWsAvailable(() => {
      easyapi.getOsdAndImageList().then(() => {
        //
      })
    })
  }
})
